import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardHeader, Col, Row, FormGroup, Form } from 'reactstrap';
import InputGroup from '../../../components/cms/form/inputGroup';
import SubmitButtons from '../../../components/cms/form/submitButtons';
import InputFile from '../../../components/cms/form/inputFile';
import PreviewImage from '../../../components/previewImage';
import MlFields from '../../../components/cms/form/mlFields';

const twoCols = { xs: 12, md: 6 };

const Item = ({
  t,
  onChange,
  onSubmit,
  errors,
  formData,
  title,
  isSubmitting,
  isSubmittingRedirect,
  imageSrc,
}) => (
  <div>
    <Row>
      <Col md={12}>
        <Card>
          <CardHeader>
            <strong><i className="fa fa-star pr-2" />{title}</strong>
          </CardHeader>
          <CardBody>
            <Form onSubmit={onSubmit(true)}>
              <Row>
                <Col md={12}>
                  <InputGroup
                    name="name"
                    label={t('Name')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.name}
                    icon="fa fa-star"
                  />
                  <FormGroup row className="my-0">
                    <Col {...twoCols}>
                      <InputGroup
                        name="status"
                        label={t('Status')}
                        onChange={onChange}
                        errors={errors}
                        type="checkbox"
                        value={1}
                        checked={formData.status}
                      />
                    </Col>
                    <Col {...twoCols}>
                    </Col>
                  </FormGroup>
                </Col>
                {/*<Col md={3}>*/}
                  {/*<div className="">*/}
                    {/*<InputFile id="logo">*/}
                      {/*<PreviewImage src={imageSrc} className="" alt="img" height="120" />*/}
                    {/*</InputFile>*/}
                  {/*</div>*/}
                {/*</Col>*/}
              </Row>
              <Row>
                <Col md={12}>
                  <SubmitButtons
                    isSubmitting={isSubmitting}
                    onSubmit={onSubmit}
                    isSubmittingRedirect={isSubmittingRedirect}
                  />
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </Row>
  </div>
);

Item.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isSubmittingRedirect: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  imageSrc: PropTypes.string.isRequired,
};

export default Item;



// WEBPACK FOOTER //
// ./src/views/animationsLists/item/Item.jsx